import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const TabBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(16),
  flexWrap: 'wrap',
}));

export const TabBarFilters = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  gap: theme.spacing(16),
}));

export const TabBarActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  columnGap: theme.spacing(16),
}));

export const TabBarChips = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: '0 0 100%',
  marginTop: theme.spacing(8),
  '&:empty': {
    display: 'none',
  },
}));
